import { MuiThemeProvider } from "@material-ui/core";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { ThemeProvider } from "styled-components";
import App from "./App";
import ErrorBoundary from "./components/errorBoundary";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import auth from "./store/reducers/auth.reducer";
import organizacje from "./store/reducers/organizacje.reducer";
import ux from "./store/reducers/ux.reducer";
import uzytkownicy from "./store/reducers/uzytkownicy.reducer";
import settings from "./store/reducers/settings.reducer";
import { IDRaksStore } from "./store/store";
import { GlobalStyle } from "./styles/themes/GlobalStyle";
import { lightTheme } from "./styles/themes/themes";

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducer = combineReducers({
  auth,
  ux,
  organizacje,
  uzytkownicy,
  settings
});

// utrzymywanie stanu auth w storze
const persistedState = {} as IDRaksStore;
if (!window.location.href.includes("loginproxy")) {
  const authState = localStorage.getItem("authState");
  if (authState) persistedState.auth = JSON.parse(authState);
}
const store = createStore(
  reducer,
  persistedState,
  composeEnhancers(applyMiddleware(thunk))
);
store.subscribe(() => {
  if (!window.location.href.includes("loginproxy")) {
    const state = store.getState();
    localStorage.setItem("authState", JSON.stringify(state.auth));
  }
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={lightTheme}>
      <MuiThemeProvider theme={lightTheme}>
        <GlobalStyle />
        <ErrorBoundary>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
      </MuiThemeProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
